module.exports = __webpack_public_path__ + "img/pin-start.f58f943d.png";